/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import {connect} from 'react-redux'

class ListenerManageListItem extends React.Component {

    constructor(){
        super();
        this.handleCheck = this.handleCheck.bind(this);
    }

    handleCheck() {
        const {listenermanage, content} = this.props;

        if (content.type === 'passed'){
            if (!content.checked){
                let idList = listenermanage.listener_list_passed_upload;
                idList.push(content.id);
                this.props.dispatch({
                    type: 'LISTENER_LIST_CHANGE_PASSED',
                    payload: idList
                });
                let list = listenermanage.listener_passed_list;
                let index = list.findIndex((value) => {
                    return value.id === content.id
                });
                list[index].checked = true;
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_APPEND',
                    payload: list
                });
            }else {
                let idList = listenermanage.listener_list_passed_upload;
                idList.splice(idList.findIndex((value) => {
                    return value === content.id
                }),1);
                this.props.dispatch({
                    type: 'LISTENER_LIST_CHANGE_PASSED',
                    payload: idList
                });
                let list = listenermanage.listener_passed_list;
                let index = list.findIndex((value) => {
                    return value.id === content.id
                });
                list[index].checked = false;
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_APPEND',
                    payload: list
                });
            }
        }else {
            if (!content.checked){
                let idList = listenermanage.listener_list_rejected_upload;
                idList.push(content.id);
                this.props.dispatch({
                    type: 'LISTENER_LIST_CHANGE_REJECT',
                    payload: idList
                });
                let list = listenermanage.listener_rejected_list;
                let index = list.findIndex((value) => {
                    return value.id === content.id
                });
                list[index].checked = true;
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_APPEND',
                    payload: list
                });
            }else {
                let idList = listenermanage.listener_list_rejected_upload;
                idList.splice(idList.findIndex((value) => {
                    return value === content.id
                }),1);
                this.props.dispatch({
                    type: 'LISTENER_LIST_CHANGE_REJECT',
                    payload: idList
                });
                let list = listenermanage.listener_rejected_list;
                let index = list.findIndex((value) => {
                    return value.id === content.id
                });
                list[index].checked = false;
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_APPEND',
                    payload: list
                });
            }
        }


    }

    render() {
        const {content} = this.props;
        return (
            <div className="listener-manage-list-item" onClick={this.handleCheck} data-id={content.id}>
                <div className="listener-manage-list-item_left">
                    <div className="listener-manage-list-item-icon">
                        <img src={content.avatar_url} alt=""/>
                    </div>
                    <div className="listener-manage-list-item-name">
                        {content.nickname}
                    </div>
                </div>
                <div className="listener-manage-list-item_right">
                    <div className={content.checked ? 'listener-manage-list-item-input listener-manage-list-item-input_active' : 'listener-manage-list-item-input'}>
                        <i className="icon iconfont icon-duigou"></i>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(state => ({
    listenermanage: state.listenermanage
}))(ListenerManageListItem)


// WEBPACK FOOTER //
// ./src/components/listenerManage/ListenerManageListItem.js